import { render, staticRenderFns } from "./EmailSupport.vue?vue&type=template&id=6d7bbf93"
import script from "./EmailSupport.vue?vue&type=script&lang=js"
export * from "./EmailSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports